"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigValue = getConfigValue;

var stage = _interopRequireWildcard(require("./stage.js"));

var prod = _interopRequireWildcard(require("./prod.js"));

/**
 * Get the config value depending on the environment
 * @param {string} env - the environment. 'prod' or 'stage'
 * @param {string} key - the field name the caller wants to know the value of
 * @return {Object} the value
 */
function getConfigValue(env, key) {
  var environmentConstants;

  if (env === 'prod') {
    environmentConstants = prod;
  } else {
    environmentConstants = stage;
  }

  return environmentConstants[key];
}